import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import Pagination from "../Pagination/Pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Table from "../Table/Table";
import { SearchInput, SearchSubmitButton } from "../Form/Form";
import { capitalizeFirstLetter } from "../../util/fn";

const OBJ_TABLE = {
  title: "title",
  "Send Type": "sendType",
  "Created At": "createdAt",
  "Total Sent": "totalCount",
  "Total Success": "totalSuccess",
  "Total Failed": "totalFailed",
};
let statusArr = {
  all_customer: "All Customer",
  all_service_provider: "All Vendors",
  both: "Both",
  custom: "Custom",
};
const searchQueryHandler = (
  page,
  per_page,
  sortBy,
  order,
  dateFrom = "",
  dateTo = "",
  sendType = ""
) => {
  sortBy =
    sortBy.length > 0
      ? sortBy === "Created At"
        ? "createdAt"
        : sortBy
      : "createdAt";
  order = order.length > 0 ? order : "desc";

  return `custom-notification/get-all?page=${page}&per_page=${per_page}&sortBy=${sortBy}&order=${order}&dateFrom=${dateFrom}&dateTo=${dateTo}&sendType=${sendType}`;
};

const CustomNotificationList = () => {
  const [emailTemplate, setEmailTemplate] = useState([]);
  const [page, setPage] = useState(1);
  const [totalDocuments, setTotalDocuments] = useState(1);
  const [perPage, setPerPage] = useState(0);
  const [currentSort, setCurrentSort] = useState({
    sortBy: "Created At",
    order: "desc",
  });

  const { records_per_page } = useSelector((state) => state.setting);

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    getValues,
    clearErrors,
  } = useForm();

  const { request, response } = useRequest();

  useEffect(() => {
    if (records_per_page) {
      setPerPage(records_per_page);
      request(
        "GET",
        searchQueryHandler(
          page,
          records_per_page,
          currentSort.sortBy,
          currentSort.order,
          "",
          "",
          ""
        )
      );
    }
    document.title = "Custom Notifications - Easyspare";
  }, [records_per_page]);

  useEffect(() => {
    if (response) {
      setEmailTemplate(response.data);
      setTotalDocuments((prev) => response?.pagination?.totalDocuments ?? prev);
    }
  }, [response]);

  const fetchMoreData = ({ selected }) => {
    setEmailTemplate([]);
    const { dateFrom, dateTo, sendType } = getValues();

    setPage(selected + 1);
    request(
      "GET",
      searchQueryHandler(
        selected + 1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        dateFrom,
        dateTo,
        sendType
      )
    );
  };

  const onSearchHandler = (data) => {
    const { dateFrom, dateTo, sendType } = data;
    request(
      "GET",
      searchQueryHandler(
        1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        dateFrom,
        dateTo,
        sendType
      )
    );
    setPage(1);
  };

  const onResetHandler = (e) => {
    e.preventDefault();
    resetField("dateFrom");
    resetField("dateTo");
    resetField("sendType");
    request(
      "GET",
      searchQueryHandler(
        1,
        perPage,
        currentSort.sortBy,
        currentSort.order,
        "",
        "",
        ""
      )
    );
    setPage(1);
  };

  const perPageChangeHandler = (event) => {
    const { dateFrom, dateTo, sendType } = getValues();
    request(
      "GET",
      searchQueryHandler(
        1,
        event.target.value,
        currentSort.sortBy,
        currentSort.order,
        dateFrom,
        dateTo,
        sendType
      )
    );
    setPage(1);

    setPerPage(event.target.value);
  };

  const sortingHandler = (sortBy) => {
    const { dateFrom, dateTo, sendType } = getValues();

    if (currentSort.sortBy == sortBy) {
      const newOrder = currentSort.order === "asc" ? "desc" : "asc";
      request(
        "GET",
        searchQueryHandler(
          page,
          perPage,
          sortBy,
          newOrder,
          dateFrom,
          dateTo,
          sendType
        )
      );
      setCurrentSort({ sortBy, order: newOrder });
    } else {
      request(
        "GET",
        searchQueryHandler(
          page,
          perPage,
          sortBy,
          "desc",
          dateFrom,
          dateTo,
          sendType
        )
      );
      setCurrentSort({ sortBy, order: "desc" });
    }
  };

  const InputFields = [
    {
      isSelectInput: true,
      label: "Send Type",
      name: "sendType",
      required: false,
      children: (
        <>
          <option value="">Select an option</option>
          <option value="all_customer">All Customer</option>
          <option value="all_service_provider">All Service Provider</option>
          <option value="both">Both</option>
          <option value="custom">Custom</option>
        </>
      ),
    },
    {
      label: "Date From",
      name: "dateFrom",
      isDate: true,
      clearErrors,
    },
    {
      label: "Date To",
      name: "dateTo",
      isDate: true,
      clearErrors,
      otherRegisterFields: {
        manual: true,
        feedback: "'To Date' cannot be smaller than 'From Date'",
      },
    },
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Custom Notifications"
        links={[{ to: "/", name: "Dashboard" }]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="row">
            <div className="col-12">
              <div className="card card-custom card-stretch card-shadowless">
                <div className="card-header">
                  <div className="card-title"></div>
                  <div className="card-toolbar">
                    <a
                      /*href="#!"*/
                      className="btn btn-primary dropdown-toggle mr-2"
                      data-toggle="collapse"
                      data-target="#collapseOne6"
                    >
                      Search
                    </a>

                    <Link
                      to="/custom-notification/send"
                      className="btn btn-primary"
                    >
                      Send Custom Notification
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div
                    className="accordion accordion-solid accordion-toggle-plus"
                    id="accordionExample6"
                  >
                    <div
                      id="collapseOne6"
                      className="collapse"
                      data-parent="#accordionExample6"
                    >
                      <div>
                        <form
                          onSubmit={handleSubmit(onSearchHandler)}
                          className="kt-form kt-form--fit mb-0"
                        >
                          <div className="row mb-6">
                            {InputFields.map((inputMain, index) => (
                              <SearchInput
                                key={index}
                                {...inputMain}
                                errors={errors}
                                register={register}
                              />
                            ))}
                          </div>

                          <SearchSubmitButton
                            handleSubmit={handleSubmit}
                            onSearchHandler={onSearchHandler}
                            onResetHandler={onResetHandler}
                          />
                        </form>
                        <hr />
                      </div>
                    </div>
                  </div>
                  <div className="dataTables_wrapper ">
                    <Table
                      currentSort={currentSort}
                      sortingHandler={sortingHandler}
                      mainData={emailTemplate}
                      tableHeading={Object.keys(OBJ_TABLE)}
                      tableData={Object.values(OBJ_TABLE)}
                      dontShowSort={[
                        "title",
                        "user",
                        "Total Sent",
                        "Total Success",
                        "Total Failed",
                      ]}
                      renderAs={{
                        title: (val, id, data) =>
                          data ? data.translations?.title : "-",

                        sendType: (val, id, data) =>
                          val ? statusArr[data?.sendType] : "-",
                      }}
                      links={[
                        {
                          isLink: true,
                          to: `/custom-notification/log`,
                          name: "View",
                          extraData: true,
                          key: "3_4",
                        },
                      ]}
                      onlyDate={{
                        createdAt: "dateTime",
                        startDate: "dateTime",
                        endDate: "dateTime",
                      }}
                    />

                    {perPage !== 0 && (
                      <Pagination
                        page={page}
                        totalDocuments={totalDocuments}
                        getNewData={fetchMoreData}
                        perPage={perPage}
                        defaultPerPage={records_per_page}
                        perPageChangeHandler={perPageChangeHandler}
                        currentDocLength={emailTemplate.length}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomNotificationList;
